import { render, staticRenderFns } from "./CoaItems.vue?vue&type=template&id=7791edd1&scoped=true&"
import script from "./CoaItems.vue?vue&type=script&lang=js&"
export * from "./CoaItems.vue?vue&type=script&lang=js&"
import style0 from "./CoaItems.vue?vue&type=style&index=0&id=7791edd1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7791edd1",
  null
  
)

export default component.exports